import { Carousel } from "@material-tailwind/react";
import { sliderProduct1, articleImg, semImg } from "../assets/images";

export default function CarouselTransition() {
  return (
    <Carousel
      className="relative"
      transition={{ duration: 2 }}
      autoplay={true}
      autoplayDelay={5000}
      loop={true}
      navigation={({ setActiveIndex, activeIndex, length }) => (
        <div className="absolute bottom-4 left-1/2 z-40 flex transform -translate-x-1/2 gap-2" aria-label="Navigation du carrousel">
          {new Array(length).fill("").map((_, i) => (
            <button
              key={i}
              className={`block h-1 cursor-pointer rounded-full transition-all ${activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"}`}
              onClick={() => setActiveIndex(i)}
              aria-label={`Aller à la diapositive ${i + 1}`}
              aria-current={activeIndex === i ? "true" : "false"}
            />
          ))}
        </div>
      )}
    >
      <img
        src={sliderProduct1}
        alt="Produits fermiers de Moide Ferme - Viande, volaille et bétail de qualité"
        className="h-full w-full object-cover object-center rounded-md"
      />
      <img
        src={articleImg}
        alt="Articles et ressources sur l'agriculture et l'élevage"
        className="h-full w-full object-cover object-center rounded-md"
      />
      <img
        src={semImg}
        alt="Services d'élevage et consultation agricole"
        className="h-full w-full object-cover object-center rounded-md"
      />
    </Carousel>
  );
}
